@if (!this.loading && !cliente) {
  <app-breadcrumb
    listado="/main/administracion/clientes"
    etiquetaListado="Clientes"
    [titulo]="cliente?.nombre"
  ></app-breadcrumb>
  <app-empty-state
    icon="business"
    message="No se encontró el cliente"
  ></app-empty-state>
} @else if (!this.loading && cliente) {
  <app-breadcrumb
    listado="/main/administracion/clientes"
    etiquetaListado="Clientes"
    [titulo]="cliente?.nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>business</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ cliente.nombre }}</h1>
      <div class="encabezado-chips">
        @if (cliente.tipoCliente) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ cliente.tipoCliente }}
          </span>
        }
        @if (cliente.estadoDeCuenta) {
          <span [class]="'chip estado-' + tonoEstadoCuenta">
            <mat-icon>manage_accounts</mat-icon>
            {{ cliente.estadoDeCuenta }}
          </span>
        }
        @if (cliente.habilitado === false) {
          <span class="chip estado-alerta">Deshabilitado</span>
        }
        @if (cliente.activo === false) {
          <span class="chip estado-alerta">Inactivo</span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar cliente"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-cliente-info
          [cliente]="cliente"
        ></app-detalles-cliente-info>
      </ng-template>
    </mat-tab>

    <!-- Historial Eventos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="idCliente"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <!-- Notas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="idCliente"
          [idCliente]="idCliente"
          tipo="Nota"
          tipoAsignado="Cliente"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Contactos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="idCliente"
          [idCliente]="idCliente"
          tipo="Contacto"
          tipoAsignado="Cliente"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="business"
    listado="/main/administracion/clientes"
    etiquetaListado="Clientes"
    [pestanas]="4"
  ></app-detalle-esqueleto>
}
